export default __webpack_public_path__ + "static/media/hht1_storybook_12.53ab3289.png";